'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
require('./Alert.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Alert = function (_a) {
    var alertList = _a.alertList, position = _a.position, autoClose = _a.autoClose, autoCloseTime = _a.autoCloseTime, alertClose = _a.alertClose;
    var _b = React.useState(alertList), list = _b[0], setList = _b[1];
    React.useEffect(function () {
        setList(tslib_es6.__spreadArrays(alertList));
    }, [alertList]);
    var deleteAlert = function (alertId, alertItemIndex) {
        list.splice(alertItemIndex, 1);
        setList(tslib_es6.__spreadArrays(list));
        alertClose(alertId);
    };
    React.useEffect(function () {
        var interval = setInterval(function () {
            if (autoClose && alertList.length && list.length) {
                deleteAlert(alertList[0].id, 0);
            }
        }, autoCloseTime);
        return function () {
            clearInterval(interval);
        };
    }, [alertList, autoClose, autoCloseTime, list]);
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("div", { className: "lp__notification--container " + position }, list.map(function (alert, index) { return (React__default['default'].createElement("div", { key: alert.id, className: "lp__notification " + position + " " + alert.type },
            React__default['default'].createElement("div", { className: "lp_alert--" + alert.type }),
            React__default['default'].createElement("div", { className: "lp__notification--alert" },
                React__default['default'].createElement("button", { type: "button", onClick: function () { return deleteAlert(alert.id, index); } }, "X"),
                alert.title && (React__default['default'].createElement("p", { className: "lp__notification--title" }, alert.title)),
                React__default['default'].createElement("p", { className: "lp__notification--message " + alert.type }, alert.description)))); }))));
};

exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map
